module.exports = __webpack_public_path__ + "static/media/logo-white@200x.9adde695.png";